__turbopack_context__.v({
  "active": "page-module__8IWCPW__active",
  "applyBtnSidebar": "page-module__8IWCPW__applyBtnSidebar",
  "avatar": "page-module__8IWCPW__avatar",
  "card": "page-module__8IWCPW__card",
  "inviteBox": "page-module__8IWCPW__inviteBox",
  "logoutBtn": "page-module__8IWCPW__logoutBtn",
  "mainContent": "page-module__8IWCPW__mainContent",
  "profileContainer": "page-module__8IWCPW__profileContainer",
  "roleText": "page-module__8IWCPW__roleText",
  "sideNav": "page-module__8IWCPW__sideNav",
  "sidebar": "page-module__8IWCPW__sidebar",
  "statCard": "page-module__8IWCPW__statCard",
  "statValue": "page-module__8IWCPW__statValue",
  "statsGrid": "page-module__8IWCPW__statsGrid",
  "userInfo": "page-module__8IWCPW__userInfo",
});
